import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { useEvaluationActions } from "@_recoil/_actions";
import { evaluationAtom } from "@_recoil/_state";
import { swalError } from "@unisearch/helpers";
import styles from "./evaluation_department.module.scss";

const EvaluationDepartment = () => {
  const evaluationActions = useEvaluationActions();
  const { specializationId, specializations, departments } =
    useRecoilValue(evaluationAtom);
  const [{ departmentIds, is_loading }, setDepartmentIds] =
    useRecoilState(evaluationAtom);

  const selectedSpecialization = specializations.filter(
    (sp) => sp.specializationId == specializationId
  )[0];

  useEffect(() => {
    //get sub Specializations
    evaluationActions.getSubSpecializations(specializationId).catch((error) => {
      swalError(error);
    });
  }, [specializationId]);

  //Handle Departments
  const handleDepartments = (event) => {
    //get target value
    const { value, checked } = event.target;

    //when unchecked remove form selected
    if (!checked) {
      setDepartmentIds((prev) => ({
        ...prev,
        departmentIds: departmentIds.filter((id) => id != value),
      }));
      return false;
    }

    //checked store max 3 coutnries
    if (departmentIds.length >= 3) {
      swalError("You can select max 3 Departments");
      return false;
    }

    if (checked) {
      setDepartmentIds((prev) => ({
        ...prev,
        departmentIds: [...prev.departmentIds, parseInt(value)],
      }));
    }
  };

  useEffect(() => {
    if (departmentIds.length) {
      setDepartmentIds((prev) => ({
        ...prev,
        show_next: true,
      }));
    }
  }, [departmentIds]);

  return (
    <>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>
          Which Discipline Do You Wish to Specialise in Under “
          {selectedSpecialization?.specializationName}”? (Up to 3)
        </div>
      </div>
      <div className={styles.content}>
        <ul>
          {departments.length > 0 &&
            departments.map((item, i) => {
              return (
                <li key={item.slug}>
                  <label
                    htmlFor={item.specializationId}
                    className={
                      departmentIds.includes(parseInt(item.specializationId))
                        ? styles.checked
                        : ""
                    }
                  >
                    <input
                      style={{ display: "none" }}
                      type="checkbox"
                      id={item.specializationId}
                      name="spsub"
                      onChange={handleDepartments}
                      value={item.specializationId}
                      checked={
                        departmentIds.includes(parseInt(item.specializationId))
                          ? true
                          : false
                      }
                    />

                    <div className={styles.name}>
                      {item?.specializationName}
                    </div>
                  </label>
                </li>
              );
            })}
        </ul>
      </div>
    </>
  );
};

export default EvaluationDepartment;
